import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiVideo, FiUsers, FiZap, FiLayout, FiMessageSquare, FiTrendingUp, FiBarChart2, FiMail, FiTarget, FiCheck } = FiIcons;

const Features = () => {
  const features = [
    { icon: FiVideo, title: "Automated Webinar (Evergreen)", description: "Run evergreen, just-in-time, ongoing series, and multi-day webinars & challenges" },
    { icon: FiUsers, title: "Unlimited Webinars, Registrants & Attendees", description: "No caps or restrictions - scale your webinars without limits" },
    { icon: FiLayout, title: "Full Webinar Funnel Builder", description: "Complete funnel builder with all page hosting included and fully brandable" },
    { icon: FiMessageSquare, title: "Live Chat and Questions Box", description: "Engage with attendees in real-time with interactive chat and Q&A" },
    { icon: FiTrendingUp, title: "Conversion Boosting Offers", description: "Built-in offer system to maximize conversions during webinars" },
    { icon: FiBarChart2, title: "Simple Yet Powerful Analytics", description: "Track performance with easy-to-understand metrics and insights" },
    { icon: FiMail, title: "Automatic Email Reminders", description: "Automated reminder sequences to boost show-up rates" },
    { icon: FiTarget, title: "Advanced Remarketing Segmentation", description: "Segment and retarget attendees based on behavior and engagement" },
    { icon: FiZap, title: "Live, Just-in-Time & Multi-Day Webinars", description: "Run live webinars, just-in-time events, and multi-day challenges" }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="font-serif text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Everything coaches need to <span className="gradient-text">sell, scale & automate</span> webinars
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Premium features designed specifically for serious coaches and trainers
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="blue-card-shine rounded-xl p-8 transition-all duration-300 group"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -10, transition: { duration: 0.2 } }}
            >
              <div className="mb-6">
                <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mb-4 group-hover:bg-white/30 transition-colors">
                  <SafeIcon icon={feature.icon} className="text-white text-2xl" />
                </div>
                <h3 className="font-bold text-xl mb-3 text-white">{feature.title}</h3>
                <p className="text-blue-100 leading-relaxed">{feature.description}</p>
              </div>
              <div className="flex items-center text-gold">
                <SafeIcon icon={FiCheck} className="mr-2" />
                <span className="text-sm font-medium">Included in all plans</span>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="text-center mt-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <div className="bg-gradient-to-r from-blue-50 to-blue-100 border border-blue-200 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="font-serif text-2xl font-bold mb-4 text-gray-900">
              Ready to transform your webinar game?
            </h3>
            <p className="text-lg text-gray-700 mb-6">
              Join 1000+ successful coaches already using My Webinar
            </p>
            <motion.button
              className="shake-shine-cta bg-primary-blue hover:bg-dark-blue text-white px-8 py-4 rounded-xl font-bold text-lg transition-all border-2 border-gold"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Get FY End Access Now
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Features;